const Logo = ({ darkMode }) => (
  <div className="flex items-center space-x-2">
    <svg className="h-8 w-auto" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Diamond Shape */}
      <path 
        d="M20 0L40 20L20 40L0 20L20 0Z" 
        className={`${darkMode ? 'fill-white' : 'fill-primary-600'}`}
      />
      <path 
        d="M20 5L35 20L20 35L5 20L20 5Z" 
        className={`${darkMode ? 'fill-primary-800' : 'fill-white'}`}
      />
      <path 
        d="M20 10L30 20L20 30L10 20L20 10Z" 
        className={`${darkMode ? 'fill-white' : 'fill-primary-600'}`}
      />
    </svg>
    
    {/* Text */}
    <div className={`flex flex-col leading-tight ${darkMode ? 'text-white' : 'text-gray-900'}`}>
      <div className="flex items-baseline">
        <span className="text-lg font-extrabold tracking-tight">QUICK -</span>
        <span className="text-lg font-light tracking-wider ml-1.5">WEALTH</span>
      </div>
      <span className="text-xs font-medium tracking-widest uppercase">
        Investments
      </span>
    </div>
  </div>
);

export default Logo; 